import http from "./http"
import { getToken } from './auth'

const base = 'Clients'

export const getPaginatedClients = async (pageNumber, pageSize, searchText) => {

    const params = new URLSearchParams()
    params.append('pageNumber', pageNumber)
    params.append('pageSize', pageSize)

    searchText && params.append('searchText', searchText)

    const { data } = await http.get(`${base}/paginated`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        },
        params
    })
    return data
}

export const getClientsAsOptions = async (searchText) => {

    const params = new URLSearchParams()
    searchText && params.append('searchText', searchText)

    const { data } = await http.get(`${base}/options-search`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        },
        params
    })
    return data
}

// Best-effort duplicate lookup (phone compared by digits, email exactly, name
// by exact match). Used by the Ask Soroby scan flow before creating a client.
export const checkClientDuplicate = async ({ phone, email, firstName, lastName }) => {

    const params = new URLSearchParams()
    phone && params.append('phone', phone)
    email && params.append('email', email)
    firstName && params.append('firstName', firstName)
    lastName && params.append('lastName', lastName)

    const { data } = await http.get(`${base}/duplicate-check`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        },
        params
    })
    return data
}

export async function getClientById(id) {
    const { data } = await http.get(`${base}/${id}`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

// Client detail dashboard — KPIs + recent jobs + recent activity in one call.
export async function getClientStats(id) {
    const { data } = await http.get(`${base}/${id}/stats`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

// On-demand geocoding — called by the address map modal only when a client
// has no stored coordinates yet. Already-geocoded clients short-circuit on
// the backend with no external call.
export async function geocodeClient(id) {
    const { data } = await http.get(`${base}/${id}/geocode`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

export async function validateAddress(payload) {
    const { data } = await http.post(`${base}/validate-address`, payload, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken(),
        }
    })
    return data
}

export async function createClient(payload) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken(),
        }
    }

    const { data } = await http.post(base + '/', payload, config)
    return data
}

export async function updateClient(payload) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken(),
        }
    }

    const { data } = await http.patch(base + '/' + payload.id, payload, config)
    return data
}

// Avatar upload — sends the raw image file; the API stores it in the Supabase
// bucket and returns { avatarUrl }.
export async function uploadClientAvatar(id, file) {
    const { data } = await http.patch(`${base}/${id}/avatar`, file, {
        headers: {
            'Content-Type': file.type,
            'Authorization': 'Bearer ' + getToken(),
        }
    })
    return data
}

export async function deleteClient(id) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken(),
        }
    }

    const { data } = await http.delete(base + '/' + id, config)
    return data
}

export async function getClientInvoices(id) {
    const { data } = await http.get(`${base}/${id}/invoices`, {
        headers: { 'Authorization': 'Bearer ' + getToken() }
    })
    return data
}
